var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIrokoTvPlain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid slice",
    xmlns: "http://www.w3.org/2000/svg",
    width: "300px",
    height: "85px",
    viewBox: "0 0 195 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.8265 41.7866V0.0583603H106.589V18.9674L122.58 0H130.925L113.65 19.9595L131.801 41.7866H122.638L106.589 22.294V41.7866H98.8265Z",
    transform: "translate(0 7)",
    fill: "#011B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.402 0.0008549C152.333 0.000284967 152.264 0 152.195 0C139.934 0 131.012 8.74014 131.012 20.94C131.012 33.1398 139.934 41.88 152.195 41.88C163.167 41.88 171.488 34.81 173.052 24.5117H164.071C162.796 30.2158 158.426 34.2323 152.195 34.2323C144.669 34.2323 139.874 28.4663 139.874 20.94C139.874 13.353 144.669 7.64765 152.195 7.64765C152.264 7.64765 152.333 7.64815 152.402 7.64915V0.0008549Z",
    transform: "translate(0 7)",
    fill: "#011B33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4701 41.88C84.6699 41.88 93.5922 33.1398 93.5922 20.94C93.5922 8.74014 84.6699 0 72.4701 0C60.2096 0 51.2874 8.74014 51.2874 20.94C51.2874 33.1398 60.2096 41.88 72.4701 41.88ZM72.4701 34.2323C64.9439 34.2323 60.1489 28.4663 60.1489 20.94C60.1489 13.353 64.9439 7.64765 72.4701 7.64765C79.9357 7.64765 84.7306 13.353 84.7306 20.94C84.7306 28.4663 79.9357 34.2323 72.4701 34.2323Z",
    transform: "translate(0 7)",
    fill: "#011B33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61878 0.667677V41.1516H0V0.667677H8.61878Z",
    transform: "translate(0 7)",
    fill: "#011B33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1131 25.7349L48.2782 41.1516H38.3241L30.373 26.7668H24.0606V41.1516H15.4418V0.667677H34.3789C42.8155 0.667677 48.0354 6.19097 48.0354 13.7172C48.0354 20.8186 43.4832 24.7031 39.1131 25.7349ZM24.0606 19.1798H33.165C36.5639 19.1798 39.1738 17.1162 39.1738 13.6565C39.1738 10.3183 36.5639 8.25463 33.165 8.25463H24.0606V19.1798Z",
    transform: "translate(0 7)",
    fill: "#011B33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.844 21.9185V4.10766H172.219V0H154.737V4.10766H161.144V21.9185H165.844Z",
    transform: "translate(0 7)",
    fill: "#011B33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M184.247 21.9185L192.692 0H187.402L181.322 16.825L175.243 0H169.952L178.398 21.9185H184.247Z",
    transform: "translate(0 7)",
    fill: "#011B33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrokoTvPlain);
export default __webpack_public_path__ + "static/media/IrokoTV-Plain.e77277d36db45402edaab553ba744d2f.svg";
export { ForwardRef as ReactComponent };